import React from 'react'
import ReactDOM from 'react-dom/client'
import App, { ErrorBoundary } from './App.tsx'
import './index.css'

// v2 — backend-connected
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
